import {Entity, Cartesian3, PropertyBag, Math as CesiumMath, HeadingPitchRoll, Transforms} from 'cesium';
import {Label as getLabelStyle, Point as getStyle, setEntityStyle} from '../renderer';

export const getOrientation = (position, rotate) => {
    const heading = CesiumMath.toRadians(rotate);
    const pitch = 0;
    const roll = 0;
    const hpr = new HeadingPitchRoll(heading, pitch, roll);
    return new Transforms.headingPitchRollQuaternion(position, hpr);
}
export default class Model extends Entity {
    constructor(options) {
        const {geometry, properties, label, model, ...other} = options;

        const {url, rotate, ...modelVal} = model;

        const position = Cartesian3.fromDegrees(...geometry);

        let orientation;
        if (rotate) {
            orientation = getOrientation(position, rotate);
        }

        let props = {
            clampToGround: true,
            position: Cartesian3.fromDegrees(...geometry),
            properties: new PropertyBag(properties),
            model: {
                uri: url,
                ...modelVal,
            },
            orientation,
            ...other
        };

        // 添加label
        if (label?.text) {
            props.label = getLabelStyle(label);
        }

        super(props);

        this.geometry = geometry;
    }

    setUrl(url) {
        this._model._uri.setValue(url);
    }

    setScale(scale) {
        this._model._scale.setValue(scale);
    }

    setRotate(rotate) {
        let orientation = getOrientation(this._position._value, rotate);
        this.orientation = orientation;
    }

    setGeometry(geometry) {
        this.position.setValue(Cartesian3.fromDegrees(...geometry));
    }

    setProperties(properties) {
        this.properties.setValue(new PropertyBag(properties));
    }


    setLabel(label) {
        this.label.setValue(getLabelStyle(label))
    }

    setStyle(style) {
        setEntityStyle(this.point, getStyle({...style}));
    }
}
